import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {IconBadgeComponent} from "../../../shared/elements/icon-badge/icon-badge.component";
import {DocumentService} from "../../../shared/services/document.service";
import {FileStorageResource} from '../../../shared/types/settings-types/fileStorageResource';

@Component({
    selector: 'app-item-documents-preview-available',
    imports: [
        TooltipComponent,
        IconBadgeComponent,
        NgOptimizedImage
    ],
    templateUrl: './item-documents-preview-available.component.html',
    styleUrl: './item-documents-preview-available.component.scss'
})
export class ItemDocumentsPreviewAvailableComponent {
  public documentService: DocumentService = inject(DocumentService);


  @Input() public file: FileStorageResource | null = null;
  @Input() public files: FileStorageResource[] = [];
  @Input() public selectable: boolean = true;
  @Output() public  filesChange: EventEmitter<FileStorageResource[]> = new EventEmitter<FileStorageResource[]>();

  public openGallery(document: FileStorageResource): void {
    this.documentService.showGallery([document], document);
  }

  public isSelected(document: FileStorageResource): boolean {
    return this.files.some(file => file.id === document.id);
  }

  public selectDocument(document: FileStorageResource): void {
    if (this.isSelected(document)) {
      this.files = this.files.filter(file => file.id !== document.id);
    } else {
      this.files.push(document);
    }
    this.filesChange.emit(this.files);
  }

}
